export default __webpack_public_path__ + "static/media/116-BG-201F.6d990199.png";